import { parseSettingsContent } from './catalogSync';

export type DeviceInstance = {
  id: string;
  type: string;
  enable?: boolean;
};

function asObject(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};
}

export function readDevicesFromSettings(content: string): DeviceInstance[] {
  const settings = parseSettingsContent(content);
  const graph = asObject(settings);
  const devices = Array.isArray(graph.devices) ? graph.devices : [];
  return devices
    .filter((item): item is Record<string, unknown> => !!item && typeof item === 'object')
    .map((item) => ({
      id: String(item.id || ''),
      type: String(item.type || ''),
      enable: item.enable !== false,
    }))
    .filter((item) => item.id);
}

export function signalHardwareDeviceIds(content: string): string[] {
  return readDevicesFromSettings(content)
    .filter((item) => item.type === 'stacklight' && item.enable !== false)
    .map((item) => item.id);
}

export function displayPanelFromSettings(content: string): string | null {
  const settings = parseSettingsContent(content);
  const display = asObject(settings.display);
  const panel = String(display.panel || '').trim();
  return panel || null;
}

export function hasDeviceId(content: string, deviceId: string): boolean {
  return readDevicesFromSettings(content).some((item) => item.id === deviceId);
}
